import { render } from "./Detail.vue?vue&type=template&id=fc66c71a&scoped=true"
import script from "./Detail.vue?vue&type=script&lang=js"
export * from "./Detail.vue?vue&type=script&lang=js"

import "./Detail.vue?vue&type=style&index=0&id=fc66c71a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-fc66c71a"

export default script